(function() {
  const loadMoreButton = document.querySelector("#load-more");

  loadMoreButton.addEventListener("click", e => {
    e.preventDefault();

    const hiddenRow = document.querySelector(".logo-list__row--hidden");

    if (hiddenRow) {
      hiddenRow.classList.remove("logo-list__row--hidden");
      hiddenRow.setAttribute("aria-hidden", "false");
    }

    const nextHiddenRow = document.querySelector(".logo-list__row--hidden");

    // Hide the "load more" link if there isn't another "logo row" present
    // to prevent future clicks.
    if (!nextHiddenRow) {
      loadMoreButton.classList.add("display--none");
      loadMoreButton.setAttribute("aria-hidden", "true");
      loadMoreButton.setAttribute("tabindex", "-1");
    }
  });
})();
